import { z } from 'zod';
import { displayNameSchema, emailSchema, handleSchema, passwordSchema, personNameSchema } from './common.js';
export const registerBodySchema = z.object({
    email: emailSchema,
    password: passwordSchema,
    firstName: personNameSchema,
    lastName: personNameSchema,
    handle: handleSchema,
});
/** Loose on purpose: format problems answer { available:false, reason:'invalid' }
 *  in the handler (via handleSchema.safeParse) instead of a 400, so the client's
 *  live tick/cross stays one code path. */
export const verifyEmailQuerySchema = z.object({
    token: z.string().min(1).max(128),
});
export const handleAvailableQuerySchema = z.object({
    handle: z.string().trim().min(1).max(64),
});
export const loginBodySchema = z.object({
    email: emailSchema,
    password: z.string().min(1).max(200), // allow short on login; we don't leak length rules
});
export const refreshBodySchema = z.object({
    refreshToken: z.string().min(1),
});
export const logoutBodySchema = z.object({
    refreshToken: z.string().min(1),
});
export const passwordResetRequestSchema = z.object({
    email: emailSchema,
});
export const passwordResetConfirmSchema = z.object({
    token: z.string().min(1),
    newPassword: passwordSchema,
});
export const authTokensResponseSchema = z.object({
    accessToken: z.string(),
    refreshToken: z.string(),
    accessTokenExpiresAt: z.string(),
    refreshTokenExpiresAt: z.string(),
});
// -------- Sign-in routing (password-primary driver auth, 2026-08-19) --------
/** `/auth/start`: which door the client should show for this email.
 *  Returns 'password' when a password exists (or the email is a fixed-
 *  password reviewer account), 'code' otherwise — unknown emails answer
 *  'code', same as passwordless ones. Ruled acceptable for v1: the app is
 *  invite-only, so has-password-vs-not is the only bit exposed. */
export const authStartBodySchema = z.object({ email: emailSchema });
// -------- Email OTP + join codes (S79 wave B) --------
export const otpRequestBodySchema = z.object({ email: emailSchema });
export const otpVerifyBodySchema = z.object({
    email: emailSchema,
    code: z.string().trim().regex(/^\d{6}$/, 'Six digits'),
});
export const otpCompleteBodySchema = z.object({
    signupToken: z.string().min(1).max(128),
    handle: handleSchema,
    displayName: displayNameSchema.optional(),
    joinCode: z.string().trim().min(4).max(12).optional(),
    /** Password-primary driver auth: the account is born WITH its hash when
     *  the app collects a password during first sign-in. Optional so existing
     *  callers (community-app onboarding) stay passwordless-by-default. */
    password: passwordSchema.optional(),
});
export const joinCodeParamSchema = z.object({
    code: z.string().trim().min(4).max(12),
});
//# sourceMappingURL=auth.js.map